import { LangContext, LangContextType } from "../../../utilities/customHooks";
import { useSuspenseQuery } from "@tanstack/react-query";
import { getUserProfile } from "../../../services/userService";
import { useUpdateUserProfile } from "../../../services/userMutations";
import * as T from "../../../utilities/frontendTypes";
import Form, { FormData } from "../../../Components/Form/Form";
import { useContext, useState } from "react";
import { adminProfileFormDefinition } from "../../../utilities/formDefinitionTemplates";
import ContentPageTopButtons from "../../../Components/ContentPageTopButtons";
import { contentPageWrapperStyle } from "./PartnerAdminList";
import { DetailsContentHeader, formContainerStyle, formWrapperStyle } from "./NewAdmin";
import { ButtonProp } from "../../../Components/Button";
import textData from "../../../textData.json";

// The profile form edits only the flat name/email fields — emailPreferences
// lives in Settings → Personal and is never part of this form's payload.
type AdminProfileFormShape = Pick<T.AdminProfile, "firstName" | "lastName" | "email">;

function AdminProfile() {
  const { langState } = useContext(LangContext) as LangContextType

  const [formDisabledState, setFormDisabledState] = useState(true);

  const { data: adminProfileData } = useSuspenseQuery({
    queryKey: ["adminProfile"],
    queryFn: () => getUserProfile("partnerAdmin"),
  });

  const adminProfile = adminProfileData.profile as AdminProfileFormShape | null;

  const updateProfile = useUpdateUserProfile("partnerAdmin");

  function handleSave(updatedFormData: FormData) {
    updateProfile.mutate(updatedFormData as AdminProfileFormShape, {
      onSuccess: () => setFormDisabledState(true),
    });
  }

  const primaryButtonProp: ButtonProp = {
    buttonText: textData.Pages.AdminPages.ProfilePages.AdminProfile.Save[langState],
    actionHandler: handleSave,
  }

  return (
    <div className={contentPageWrapperStyle}>
      <ContentPageTopButtons 
        editCallback={() => setFormDisabledState(!formDisabledState)}
      />
      <DetailsContentHeader 
        label={`${adminProfile ? `${adminProfile.firstName}'s` : textData.Pages.AdminPages.ProfilePages.AdminProfile.New[langState] } ${textData.Pages.AdminPages.ProfilePages.AdminProfile.Profile[langState]}`}
        tooltip={textData.Pages.AdminPages.ProfilePages.AdminProfile.Tooltip[langState]}
      />
      <div className={formContainerStyle}> 
        <div className={formWrapperStyle}>
          <Form
            formData={adminProfile}
            formDefinition={adminProfileFormDefinition}
            primaryButtonProp={primaryButtonProp}
            disabled={formDisabledState}
          />
        </div>
      </div>
    </div>
  )
}

export default AdminProfile;